module.exports = __webpack_public_path__ + "media/images/emblems/Adliswil-blazon-5bdc862ece05d4310c2a0071e151c25e.svg";